export default __webpack_public_path__ + "static/media/background.fe03f79d.jpg";